import { render, staticRenderFns } from "./EndTermResultRow.vue?vue&type=template&id=70dcb24a"
import script from "./EndTermResultRow.vue?vue&type=script&lang=js"
export * from "./EndTermResultRow.vue?vue&type=script&lang=js"
import style0 from "./EndTermResultRow.vue?vue&type=style&index=0&id=70dcb24a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports